import { render, staticRenderFns } from "./SimpleInput.vue?vue&type=template&id=33d75ea1"
import script from "./SimpleInput.vue?vue&type=script&lang=ts"
export * from "./SimpleInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports